import { X } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

interface LastSearchBannerProps {
  fields: Array<{ label: string; value: string }>;
  searchedAt: string;
  onClear: () => void;
  isClearing?: boolean;
}

/**
 * Shows the criteria that produced the currently-displayed search results,
 * plus when the search ran and a way to clear it. Shared between Contract
 * Search and Client Search — each page builds its own `fields` list from its
 * own criteria shape.
 */
export function LastSearchBanner({
  fields,
  searchedAt,
  onClear,
  isClearing,
}: LastSearchBannerProps) {
  return (
    <Card>
      <CardContent className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-sm font-medium text-muted-foreground">Showing results for:</span>
          {fields.map((field) => (
            <Badge key={field.label} variant="secondary">
              {field.label}: {field.value}
            </Badge>
          ))}
          <span className="text-xs text-muted-foreground">
            Searched {new Date(searchedAt).toLocaleString()}
          </span>
        </div>
        <Button variant="ghost" size="sm" onClick={onClear} disabled={isClearing} className="gap-1">
          <X className="h-4 w-4" />
          Clear results
        </Button>
      </CardContent>
    </Card>
  );
}
